package app.nestbridge.domain.ping.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HttpBinHeadersResponse(
    @SerialName("headers")
    val headers: Map<String, String>,
)
